import Client from './client';

export default class ProductReviewHistories extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/products/${id}/histories`, options);
  }

}
